<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="breakpoints.lgAndUp ? '40%' : '85%'"
    top="20vh"
    :before-close="handleClose"
    custom-class="custom-scrollable"
    test-id="withdrawalDialog"
  >
    <div class="font-normal mb-6 pb-4 text-black-2">
      <div class="flex justify-center mt-10"><withdrawal-error /></div>
      <div
        test-id="error"
        class="font-bold text-xl text-black-2 flex justify-center my-4"
      >
        Withdrawal Error
      </div>
      <div class="text-center mx-10 px-8 text-lg">
        Can’t initiate withdrawal at the moment <br />
        <span class="italic">
          Please Kindly reach out to our customer support:</span
        >
        <span
          class="italic text-primary cursor-pointer"
          @click="contactSupport"
          test-id="supportButton"
        >
          accounts@ovalfi.com
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    contactSupport () {
      this.$emit('contactSupport')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    WithdrawalError: () => import('@/assets/images/WithdrawalError.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
